"use strict";
/*eslint radix: ["error", "as-needed"]*/
const angular = require("angular");

import _ from "underscore";

export class ValidationController {
  constructor(
    arrow,
    appConfig,
    $location,
    Modal,
    LanguageService,
    ProductAPI,
    Condition,
    screenSize
  ) {
    "ngInject";
    var that = this;
    this.isMobile = screenSize.on("xs", function (match) {
      that.isMobile = match;
    });
    let ovhBase =
      "https://storage.sbg.cloud.ovh.net/v1/AUTH_bcdf554d7a774b40975e6151a6bd1b8a/dal_";
    this.ovhBaseURI = ovhBase + appConfig.env + "/";
    this.spinnerEnabled = true;
    this.arrow = arrow;
    this.ProductAPI = ProductAPI;
    this.Modal = Modal;
    this.$location = $location;
    that.getBoolean = Condition.getBoolean;

    this.ls = LanguageService;
    this.s = $location.search();
    if (this.s.demand && parseInt(this.s.demand)) {
      if (this.s.project && parseInt(this.s.project)) {
        ProductAPI.getModels()
          .$promise.then(function (response) {
            response = JSON.parse(JSON.stringify(response));
            if (response.length > 0) {
              that.products = response;
              return ProductAPI.getFull({
                id: parseInt(that.s.demand),
              })
                .$promise.then((demand) => {
                  if (
                    !demand ||
                    (demand && demand.project.id != that.s.project)
                  ) {
                    $location.path("/permission").search({});
                  }
                  that.demand = JSON.parse(JSON.stringify(demand));
                  that.disabledInput = false;
                  if (
                    that.demand.status &&
                    parseInt(that.demand.status) % 10 !== 1
                  ) {
                    that.disabledInput = true;
                  }

                  let dateAmended = new Date(that.demand.dateAmended).getTime();
                  if (!that.disabledInput && that.s.date != dateAmended) {
                    that.arrow.goto(3, that.s.project, that.s.demand, false, {
                      date: dateAmended,
                    });
                  }

                  if (!that.checkClient(that.demand)) {
                    that.arrow.goto(3, that.s.project, that.s.demand, false, {
                      date: dateAmended,
                    });
                  }

                  if (
                    parseInt(that.demand.status) == 50 ||
                    parseInt(that.demand.status) == 60 ||
                    parseInt(that.demand.status) == 70 ||
                    parseInt(that.demand.status) == 74 ||
                    parseInt(that.demand.status) == 80 ||
                    parseInt(that.demand.status) == 90
                  ) {
                    that.prevIsHidden = true;
                  }

                  that.loadDemand();
                  that.spinnerEnabled = false;
                  return null;
                })
                .catch(() => {
                  $location.path("/permission");
                  that.spinnerEnabled = false;
                  return null;
                });
            }
            return;
          })
          .catch(() => {
            console.log("---> Error on load products type");
          }); // @@@ handle error by popup */
      } else {
        arrow.goto(1);
      }
    } else {
      arrow.goto(2);
    }
  }

  validate() {
    var that = this;
    if ([11, 21, 31, 41, 51].indexOf(that.demand.status) != -1) {
      this.Modal.confirm.validate(() => {
        that.validateClicked = true;
        that.demand.status = parseInt(that.demand.status) + 1;
        return that.ProductAPI.changeStatus(that.demand).$promise.then(() => {
          that.$location.path("/permission").search({
            directive: "confirmation",
            project: that.s.project,
            demand: that.s.demand,
          });
          that.validateClicked = false;
          return null;
        });
      })();
    }
  }

  checkClient(d) {
    if (!d.contactIdMain || !d.societyIdMain || !d.addressIdMain) {
      return false;
    }
    if (
      !d.mainIsFinal &&
      (!d.contactIdFinal || !d.societyIdFinal || !d.addressIdFinal)
    ) {
      return false;
    }
    if (!d.mainIsInvoice) {
      if (
        !d.finalIsInvoice &&
        (!d.contactIdInvoice || !d.societyIdInvoice || !d.addressInvoice)
      ) {
        return false;
      }
      if (
        d.finalIsInvoice &&
        (!d.contactIdFinal || !d.societyIdFinal || !d.addressIdFinal)
      ) {
        return false;
      }
    }
    return true;
  }

  getSortedIname(array) {
    let keys = [];
    for (let a in array) {
      keys.push({
        iname: a,
        rank: array[a].rank,
      });
    }
    keys = keys.sort(function (a, b) {
      return a.rank - b.rank;
    });
    return keys;
  }

  loadDemand() {
    var that = this;
    let inputs = [];
    let product = _.findWhere(that.products, {
      id: that.demand.productId,
    });

    let listedModels = product.listedModels;
    _.each(that.demand.input, function (elt) {
      let model = listedModels[`input_${elt.inputModelId}`];

      if (model.type == "author" && elt.artist) {
        elt.author = elt.artist.label;
      }
      if (model.type == "date" && elt.date) {
        elt.date = new Date(elt.date).toLocaleDateString("en-GB");
      }
      if (model.type == "file" && elt.file) {
        /*let _file = JSON.parse(JSON.stringify(elt.file));
        let _index = _file.indexOf('/');
        if(_index > -1) {
          elt.file = _file.substring(_index + 1);
        }*/

        /*let originalnames = null;
        if(elt.objFiles && elt.objFiles.length > 0) {
          originalnames = _.pluck(elt.objFiles, 'originalname').join(' , ');
        }
        elt.file = originalnames;*/
        elt.file = elt.objFiles || [];
      }

      inputs.push({
        id: elt.id,
        inputModelId: elt.inputModelId,
        iname: `input_${elt.inputModelId}`,
        useNumber: elt.useNumber,
        demandId: elt.demandId,
        isGeneral: model.isGeneral,
        type: model.type,
        parentModelId: model.inputModelId,
        rank: model.rank,
        value: elt[model.type],
        labelFr: model.labelFr,
        labelEn: model.labelEn,
        sigedavMatchType: model.sigedavMatchType, //*/
      });
    });

    inputs = _.sortBy(inputs, "rank");

    //Array to object
    let _generals = _.where(inputs, {
      isGeneral: true,
    });
    _generals = _.indexBy(_generals, "iname");
    let _uses = _.where(inputs, {
      isGeneral: false,
    });
    _uses = _.groupBy(_uses, "useNumber");
    for (var useNumber in _uses) {
      _uses[useNumber] = _.indexBy(_uses[useNumber], "iname");
    }

    //Set showed property
    let keysG = this.getSortedIname(_generals);
    for (let k in keysG) {
      let iname1 = keysG[k].iname;
      let syntShow = listedModels[iname1].showOn;
      _generals[iname1].showed = that.getBoolean(syntShow, _generals, _uses);
    }

    for (let u2 in _uses) {
      let keysU = this.getSortedIname(_uses[u2]);
      for (let k2 in keysU) {
        let iname2 = keysU[k2].iname;
        let syntShow = listedModels[iname2].showOn;
        _uses[u2][iname2].showed = that.getBoolean(
          syntShow,
          _generals,
          _uses,
          _uses[u2]
        );
      }
    }

    //Delete all select and radio button subinputs and all hidden inputs
    let inamesToDelete = [];
    for (var iname3 in _generals) {
      if (!_generals[iname3].showed) {
        inamesToDelete.push(iname3);
      }
      if (
        listedModels[iname3] &&
        listedModels[iname3].subInputModel &&
        listedModels[iname3].subInputModel.length > 0
      ) {
        this.getValueList(
          iname3,
          _generals,
          listedModels[iname3].subInputModel
        );
        inamesToDelete = inamesToDelete.concat(
          _.pluck(listedModels[iname3].subInputModel, "iname")
        );
      }
    }

    inamesToDelete = _.uniq(inamesToDelete);
    _generals = this.deleteInputs(inamesToDelete, _generals);
    for (var u1 in _uses) {
      inamesToDelete = [];
      for (var iname4 in _uses[u1]) {
        if (!_uses[u1][iname4].showed) {
          inamesToDelete.push(iname4);
        }
        if (
          listedModels[iname4] &&
          listedModels[iname4].subInputModel &&
          listedModels[iname4].subInputModel.length > 0
        ) {
          this.getValueList(
            iname4,
            _uses[u1],
            listedModels[iname4].subInputModel
          );
          inamesToDelete = inamesToDelete.concat(
            _.pluck(listedModels[iname4].subInputModel, "iname")
          );
        }
      }
      inamesToDelete = _.uniq(inamesToDelete);
      _uses[u1] = this.deleteInputs(inamesToDelete, _uses[u1]);
    }

    //Object to array
    let _tempG = [];
    for (var g in _generals) {
      _tempG.push(_generals[g]);
    }
    _generals = _tempG;
    _generals = _.sortBy(_generals, "rank");

    let _tempU = [];
    let _tempUN = _.keys(_uses);
    _tempUN.sort();
    for (let un in _tempUN) {
      let u = _tempUN[un];
      //for(var u in _uses) {
      let _temp = [];
      for (var a in _uses[u]) {
        _temp.push(_uses[u][a]);
      }
      _tempU.push(_.sortBy(_temp, "rank"));
    }
    _uses = _tempU;
    this.generals = _generals;
    this.uses = _uses;
    this.main = {
      contact: `${that.demand.contactMain.firstname} ${that.demand.contactMain.lastname}`,
      society: `${that.demand.societyMain.name} `,
      address: that.demand.addressMain.label,
    };
    this.final = JSON.parse(JSON.stringify(this.main));
    this.invoice = JSON.parse(JSON.stringify(this.main));
    if (!this.demand.mainIsFinal) {
      this.final = {
        contact: `${that.demand.contactFinal.firstname} ${that.demand.contactFinal.lastname}`,
        society: `${that.demand.societyFinal.name} `,
        address: that.demand.addressFinal.label,
      };
    }
    if (!this.demand.mainIsInvoice && this.demand.finalIsInvoice) {
      this.invoice = JSON.parse(JSON.stringify(this.final));
    }
    if (!this.demand.mainIsInvoice && !this.demand.finalIsInvoice) {
      this.invoice = {
        contact: `${that.demand.contactInvoice.firstname} ${that.demand.contactInvoice.lastname}`,
        society: `${that.demand.societyInvoice.name} `,
        address: that.demand.addressInvoice.label,
      };
    }
  }

  prev() {
    var that = this;
    let dateAmended = new Date(that.demand.dateAmended).getTime();
    that.arrow.goto(3, that.s.project, that.s.demand, false, {
      date: dateAmended,
    });
  }

  deleteInputs(inames, data) {
    for (var i in inames) {
      delete data[inames[i]];
    }
    return data;
  }

  getValueList(iname, data, models) {
    let value = [];
    for (var m in models) {
      if (data[models[m].iname] && data[models[m].iname].value) {
        let label =
          this.ls.lang == "fr" ? models[m].labelFr : models[m].labelEn;
        value.push(label);
      }
    }
    data[iname].value = value.join();
  }
}

export default angular
  .module("dalApp.permission.validation", [])
  .component("validation", {
    template: require("./validation.html"),
    controller: ValidationController,
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/validation/validation.component.js